export const config = {
  PASSKEY_TENANT_ID: '71e32924-1801-40fb-8724-b41c1c9c6f0f',
  PASSKEY_SECRET_API_KEY: '6b7141ff-42f2-46e6-8d5c-633715778102',
  PASSKEY_SECRET_SECRET_KEY: 'fQIBIl6CcZvH_cvC3HJHXyB3cTtm1GkoSrcM6HbpM8Ec8EuET-l2Dy6_udM3CG5PLza0uxriJ3VaG1ETpxmlQw=='
};
